import { LoaderCircle } from "lucide-react";

const Loading = () => {
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <div className="flex flex-col items-center">
        <LoaderCircle className="animate-spin text-blue-500" size={40} />
        <p className="text-lg text-gray-700 mt-2">Loading...</p>
      </div>
    </div>
  );
};

export default Loading;

